/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

// import {Base64} from 'js-base64';

require('./bootstrap');

/* jquery code */
require('./jquery-other');

/* react code*/
require('./maps');

// function updateDynamicUrl(){
//     console.log(window.dynamicUrlObj);
//
//     const queryString = Base64.encodeURI(JSON.stringify(window.dynamicUrlObj));
//     const newUrl = baseUrl + '?q=' + queryString;
//
//     window.history.pushState('obj', 'PRIMS', newUrl);
// }